import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Paper } from '@material-ui/core';

/**
 * Reusable information block component
 * Displays explanatory content in a styled gray box
 */
const InfoBlock = ({ title, description, items, children }) => (
  <Paper elevation={0} style={{ backgroundColor: '#f5f7f9', padding: 16, marginBottom: 16 }}>
    {title && (
      <Typography variant="body2" paragraph>
        <b>{title}</b>
        {description && (
          <>
            {' '}
            {description}
          </>
        )}
      </Typography>
    )}
    {items && items.length > 0 && (
      <Box component="ul" pl={2} mb={title ? 0 : 1}>
        {items.map((item, index) => (
          <li key={`item-${index}`}>
            <Typography variant="body2" gutterBottom={index < items.length - 1}>
              {item}
            </Typography>
          </li>
        ))}
      </Box>
    )}
    {children}
  </Paper>
);

InfoBlock.propTypes = {
  title: PropTypes.node,
  description: PropTypes.node,
  items: PropTypes.arrayOf(PropTypes.node),
  children: PropTypes.node,
};

InfoBlock.defaultProps = {
  title: null,
  description: null,
  items: null,
  children: null,
};

export default InfoBlock;
